import { initMercadoPago } from "@mercadopago/sdk-react";
import { i18n } from "../translate/i18n";

let initialized = false;

// Idioma do formulário de cartão do MP segue o do CRM (o SDK só aceita locales
// regionais). Vale para a primeira inicialização da sessão.
const MP_LOCALES = { pt: "pt-BR", en: "en-US", es: "es-AR" };

// Inicializa o SDK do Mercado Pago uma única vez (lazy, chamado pelo checkout).
// Retorna false quando a public key não está configurada no .env.
export const ensureMercadoPago = () => {
  const publicKey = process.env.REACT_APP_MP_PUBLIC_KEY;
  if (!publicKey) return false;
  if (!initialized) {
    const lang = String(i18n.language || "pt").split("-")[0];
    initMercadoPago(publicKey, { locale: MP_LOCALES[lang] || "pt-BR" });
    initialized = true;
  }
  return true;
};
